var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMvprLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 278 109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-159 -934)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.63319 0 0 .97719 570.765 383.729)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M245.68 78h-17V37.16a8.66 8.66 0 00.006-.323c0-4.893-4.027-8.92-8.92-8.92l-.216.003c-5.23 0-9 3.89-9 9.24V78h-17V37.16c.004-.111.006-.222.006-.333 0-4.888-4.022-8.91-8.91-8.91l-.216.003c-5.24 0-9 3.89-9 9.24V78h-17V37.4c0-14.35 11.44-24.33 25.91-24.33 7.79 0 14 2.92 18 8 4.26-5.11 10.58-8 18.25-8 14.6 0 25.18 10 25.18 24.33l-.09 40.6zM269.61 78L249.9 15h17.88l13.14 48.2h.49l13-48.18h17.76L292.6 78h-22.99zM355.29 80c-8.75 0-16.3-3.52-19.34-8.76h-.36a38.15 38.15 0 01.24 5.48V106h-16.91V15h15.69v2.92a51.386 51.386 0 01-.24 5.35h.37c4-6.2 11.8-10.22 21.28-10.22 17.64 0 30.42 13.75 30.42 33.46S373.18 80 355.29 80zm-20.07-33.59c0 11 7.06 18.49 17 18.49 9.94 0 17.16-7.54 17.16-18.49s-7.18-18.49-17.16-18.49-17 7.54-17 18.49z",
    transform: "matrix(1.57931 0 0 1.02334 -897.607 564.678)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M1096.62 822.979c1.64-5.829 7.02-10.163 13.34-10.186h8.03v15h-21.63l.22 49.93h-17v-63h17v2.92l-.24 5.336h.28z",
    transform: "matrix(1.57931 0 0 1.02334 -897.607 564.678) translate(-684.662 -799.723)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M423.26 75.05c.043-2.35 1.989-4.26 4.339-4.26 2.381 0 4.34 1.959 4.34 4.34s-1.958 4.34-4.339 4.34c-2.384-.011-4.34-1.976-4.34-4.36v-.06zm7.73.12a3.416 3.416 0 00-3.4-3.38 3.416 3.416 0 00-3.4 3.4c0 1.865 1.535 3.4 3.4 3.4h.01a3.436 3.436 0 003.4-3.42h-.01zm-2.55 2.31a1.611 1.611 0 01-.1-.5v-.59a.734.734 0 00-.84-.77h-.51v1.86h-1.2v-4.83h2.06c1 0 1.75.49 1.75 1.36.017.515-.298.987-.78 1.17.45.18.68.52.71 1.38a2.66 2.66 0 00.13.92h-1.22zm-.87-2.64c.48 0 .78-.2.78-.74s-.26-.62-.72-.62h-.69v1.36h.63z",
    transform: "matrix(1.57931 0 0 1.02334 -897.607 564.678)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMvprLogo);
export default __webpack_public_path__ + "static/media/mvpr-logo.63908857d315c5091a1480faebec2a10.svg";
export { ForwardRef as ReactComponent };